import React from 'react'
import ButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase'
import styled, { css } from 'styled-components'

import { SIZES } from '~/common/globalStyles'

interface BaseIconButtonProps extends ButtonBaseProps {
  dense?: boolean
  position?: 'left' | 'right'
  size?: 'small' | 'medium' | 'large'
  buttonRef?: React.Ref<HTMLButtonElement | null>
}

const BaseIconButton = React.forwardRef<HTMLButtonElement, BaseIconButtonProps>(
  (
    {
      className,
      children,
      onClick,
      onMouseDown,
      tabIndex,
      style,
      disabled,
      buttonRef,
      ...rest
    },
    ref,
  ) => {
    return (
      <ButtonBase
        {...rest}
        ref={(buttonRef ?? ref) as React.Ref<HTMLButtonElement>}
        role="button"
        className={className}
        centerRipple
        onClick={onClick}
        onMouseDown={onMouseDown}
        tabIndex={tabIndex}
        style={style}
        disabled={disabled}
      >
        {children}
      </ButtonBase>
    )
  },
)

BaseIconButton.displayName = 'BaseIconButton'

const IconButton = styled(BaseIconButton)`
  && {
    ${({ dense }) =>
      !dense &&
      css`
        width: ${SIZES.xxl};
        height: ${SIZES.xxl};
      `} padding: 0;
    border-radius: 50%;
    font-size: ${SIZES.medium};
    z-index: 99;
    ${({ position = 'left' }) => css`
      float: ${position};
    `};
  }
`

/** @component */
export default IconButton
